
window.customFunctions = {};


  window.customFunctions.stockMessageSetup = (variant) => {
    if (window.productInventories[variant.id]) {
      const variantQuantity = window.productInventories[variant.id];
      if (variantQuantity < 10 && variant.available) {
        if (!document.querySelector(".stockMessage")) {
          const stockMessage = document.createElement("div");
          stockMessage.classList.add("stockMessage");
          stockMessage.innerHTML = `
                  <p>Only a few available!</p>
              `;
          document
            .querySelector(".shopify-product-form buy-buttons")
            .parentElement.insertAdjacentElement("beforeBegin", stockMessage);
        }
      } else {
        window.customFunctions.removeStockMessage();
      }
    } else {
      window.customFunctions.removeStockMessage();
    }
  };

  window.customFunctions.removeStockMessage = () => {
    document.querySelector(".stockMessage")?.remove();
  };


window.customFunctions.handleFreeShippingMessage = (variant) => {
  if(variant && variant.available)
    document.querySelector(".freeShippingInfo")?.classList.remove('hidden');
  else
    document.querySelector(".freeShippingInfo")?.classList.add('hidden');
};


if(Shopify && Shopify.country == 'GB'){
    document.querySelectorAll('.ukOnlyFeature').forEach(el=>el.classList.remove('hidden'))
}else{
    document.querySelectorAll('.ukOnlyFeature').forEach(el=>el.remove())
}

if(document.querySelector('.template--cart')){
  //Only on the cart page, listener to make notes field an accordion
  document.querySelector('cart-note.cart-note label').addEventListener('click', e=>{
      document.querySelector('cart-note.cart-note').classList.toggle('expanded')
  })
}

if(document.querySelector('.collection-description') && myFunction){
  myFunction=()=>{
    var collectionDescription = document.querySelector('.collection-description')
    var btnText = document.getElementById("myBtn");


      collectionDescription.classList.toggle('contentSliced')
        if(collectionDescription.classList.contains('contentSliced')){
          btnText.innerHTML = "Read more";
        } else {
          btnText.innerHTML = "Read less";
        }
  }
}



if(document.querySelector('product-form form') && document.querySelector('.klaviyo-bis-trigger')){
  document.querySelector('product-form form').addEventListener("variant:change", (event)=>{
    console.log(event);

    if(!event || !event.detail || !event.detail.variant) return;
    const variant = event.detail.variant
    if(!variant.available){
        document.querySelector('.klaviyo-bis-trigger').style.display = ""
    }else{
        document.querySelector('.klaviyo-bis-trigger').style.display = "none"
    }
  })
}















